module.exports = __webpack_public_path__ + "img/690.9f0cde4a.png";